// extracted by mini-css-extract-plugin
export default {"breadcrumbs":"ActivitiesPage_breadcrumbs__L1v49"};